// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OD_Dx","content":"styles_content__2nxy_","tableWrap":"styles_tableWrap__1PCND"};